import React, { useState } from 'react';
import { Form, Col, Row } from 'react-bootstrap';
import Modal from '@rd-web-markets/shared/dist/util/Modal';
export default function ImportModal(_ref) {
  let {
    extraDescription,
    placeholder,
    show,
    onHide,
    onSubmit
  } = _ref;
  const [importData, setImportData] = useState('');
  const rateModalBody = () => {
    return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, {
      className: "mb-2",
      as: Row
    }, /*#__PURE__*/React.createElement(Col, null, "Please prepare your Excel data using the column layout displayed below, then select the relevant rows and columns in your Excel file and paste them below. Make sure your numbers are in the format ", /*#__PURE__*/React.createElement("i", null, "1,345.56"), ". Commas and decimal points are optional.", extraDescription)), /*#__PURE__*/React.createElement(Form.Group, {
      className: "mb-2",
      as: Row
    }, /*#__PURE__*/React.createElement(Col, {
      md: 12
    }, /*#__PURE__*/React.createElement(Form.Control, {
      as: "textarea",
      placeholder: placeholder,
      onChange: e => setImportData(e.target.value),
      rows: 6,
      value: importData
    }))));
  };
  return /*#__PURE__*/React.createElement(Modal, {
    size: "lg",
    title: "Import from Excel",
    show: show,
    renderBody: () => rateModalBody(),
    onHide: () => {
      onHide();
      setImportData('');
    },
    submitIcon: "upload_file",
    submitText: "Import",
    onSubmit: () => {
      onSubmit(importData);
      setImportData('');
    }
  });
}